import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import ScrollToTop from './services/Utils';

import AuthLayout from './layouts/Auth.js';
import MainLayout from './layouts/Main.js';
import ClearLayout from './layouts/Clear.js';
import DailyWheelLayout from './layouts/GiveawayDailyWheel.js';

import PrivateRoute from './private';

const queryClient = new QueryClient();
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route path={'/auth'} component={AuthLayout} />
        <Route path={'/clear'} component={ClearLayout} />
        <Route path={'/portal'} component={ClearLayout} />
        <Route path={'/giveaways/daily/wheel'} component={DailyWheelLayout} />
        <PrivateRoute path={'/'} component={MainLayout} />
      </Switch>
    </QueryClientProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
